var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "333.73 143.5 333.73 174.49 330.62 174.49 330.62 148.3 311.66 148.3 311.66 174.49 308.55 174.49 308.55 148.3 201.31 148.3 201.31 174.49 198.2 174.49 198.2 148.3 179.24 148.3 179.24 174.49 176.13 174.49 176.13 143.5 333.73 143.5",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "329.1 136.73 285.37 136.73 264.19 136.73 180.47 136.73 158.4 150.26 243.16 150.26 276.4 150.26 351.17 150.26 329.1 136.73",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-97"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.23,
    y: 148.3,
    width: 197.1,
    height: 3.27,
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-97"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "223.64 420.9 223.64 136.73 285.92 136.73 285.92 418.9",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-97"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.64,
    y: 143.5,
    width: 62.28,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "293.79 137.7 215.78 137.7 226.81 124.16 282.75 124.16 293.79 137.7",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-97"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.72,
    y: 136.06,
    width: 80.13,
    height: 3.27,
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77,145.12s2.51-9.63,19.42-9.68,26.82,16.87,26.82,16.87,7.09-7.37,15.66-2.45,8.55,7.71,8.55,7.71h22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.06,160.45s-2.51-9.64-19.42-9.69-26.82,16.88-26.82,16.88-7.09-7.37-15.66-2.45-8.55,7.71-8.55,7.71h-22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.46,143h-12.4s3.39-7.15-4.27-15.61-15.45-2.83-15.45-2.83-7.52-25.74-29.45-22.72S307.65,126,307.65,126s-4.69-5.19-14.24-1.78-11,16.48-8.63,22c0,0-10.87,2.11-11.6,11.39,0,0-.67-8.21-10.9-8.46s-12.79,12.45-12.79,12.45H238",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.31,124.58l57.36-2.86c6.31-21.09,30.17-12.27,30.17-12.27C210.87,87.57,232,98,232,98s10.72-21.08,31.88-16.67a32.91,32.91,0,0,1,25.5,23.07l14.6.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-97"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "86.08 339.36 86.08 278.82 95.58 278.82 103.88 270.51 103.88 258.51 106.65 258.51 106.65 312.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "98.14 348.16 98.14 316.58 126.62 316.58 126.62 374.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "114.31 312.43 114.31 291.98 126.62 291.98 126.62 274.86 129.86 274.86 129.86 247.32 132.46 247.32 132.46 268.27 136.19 268.27 136.19 292.5 141.19 297.5 141.19 311.06 150.43 311.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "135.05 377.98 135.05 340.22 143.04 340.22 143.04 322.02 153.59 322.02 153.59 292.5 158.4 292.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "370.38 321.1 370.38 312.43 364.06 312.43 364.06 295.59 361.42 295.59 361.42 312.23 351.17 312.23 351.17 319.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "402.89 313.4 402.89 292.11 390.43 279.65 385.68 279.65 385.68 295.59 382.52 295.59 382.52 298.44 385.68 298.44 385.68 324.02 358.25 324.02 358.25 366.83 358.25 390.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "393.46 368.03 393.46 316.58 419.97 316.58 419.97 329.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "411 312.43 411 274.86 413.64 274.86 413.64 312.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "351.17 387.95 351.17 351.31 324.7 351.31 324.7 303.37 303.23 281.89 303.23 259.52 298.66 259.52 298.66 353.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "306.08 398.53 306.08 358.25 277.91 358.25 277.91 330.65 274.24 330.65 274.24 291.15 270.86 291.15 270.86 253.55 266.35 253.55 266.35 208.41 262.39 208.41 262.39 251.83 257.16 257.05 257.16 278.82 247.66 278.82 247.66 330.61 228.52 330.61 228.52 363.6 215.78 363.6 215.78 398.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "161.39 311.06 176.31 311.06 176.31 347.19 188.15 347.19 188.15 376.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "178.64 323.3 188.15 323.3 188.15 289.18 233.5 289.18 233.5 324.02",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.13,
    y1: 316.58,
    x2: 294.31,
    y2: 316.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "337.16 348.16 337.16 284.62 333.73 284.62 333.73 349",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.73 143.5 333.73 174.49 330.62 174.49 330.62 148.3 311.66 148.3 311.66 174.49 308.55 174.49 308.55 148.3 201.31 148.3 201.31 174.49 198.2 174.49 198.2 148.3 179.24 148.3 179.24 174.49 176.13 174.49 176.13 143.5 333.73 143.5",
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-97)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "333.73 143.5 333.73 156.66 330.62 156.66 330.62 148.3 311.66 148.3 311.66 156.66 308.55 156.66 308.55 148.3 201.31 148.3 201.31 156.66 198.2 156.66 198.2 148.3 179.24 148.3 179.24 156.66 176.13 156.66 176.13 143.5 333.73 143.5",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "333.73 143.5 333.73 174.49 330.62 174.49 330.62 148.3 311.66 148.3 311.66 174.49 308.55 174.49 308.55 148.3 201.31 148.3 201.31 174.49 198.2 174.49 198.2 148.3 179.24 148.3 179.24 174.49 176.13 174.49 176.13 143.5 333.73 143.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.1 136.73 285.37 136.73 264.19 136.73 180.47 136.73 158.4 150.26 243.16 150.26 276.4 150.26 351.17 150.26 329.1 136.73",
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-97)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "329.1 136.73 285.37 136.73 264.19 136.73 180.47 136.73 158.4 150.26 243.16 150.26 276.4 150.26 351.17 150.26 329.1 136.73",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.53 136.73 224.41 136.73 224.41 150.26 307.62 150.26 290.53 136.73",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "329.1 136.73 285.37 136.73 264.19 136.73 180.47 136.73 158.4 150.26 243.16 150.26 276.4 150.26 351.17 150.26 329.1 136.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.15,
    y1: 139.33,
    x2: 325.48,
    y2: 139.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.15,
    y1: 142.21,
    x2: 216.17,
    y2: 142.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.02,
    y1: 145.54,
    x2: 290.08,
    y2: 145.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.82,
    y1: 142.21,
    x2: 303.59,
    y2: 142.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.47,
    y1: 142.21,
    x2: 323.18,
    y2: 142.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.32,
    y1: 139.33,
    x2: 332.27,
    y2: 139.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.68,
    y1: 145.54,
    x2: 318.43,
    y2: 145.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.18,
    y1: 145.54,
    x2: 326.22,
    y2: 145.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.73,
    y1: 145.54,
    x2: 343.46,
    y2: 145.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.53,
    y1: 142.21,
    x2: 192.62,
    y2: 142.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.3,
    y1: 142.21,
    x2: 206.08,
    y2: 142.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.3,
    y1: 139.33,
    x2: 182.07,
    y2: 139.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.13,
    y1: 145.54,
    x2: 181.15,
    y2: 145.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,173.59V396.32c-26.59,14-59.16,22.25-98.31,23a162.59,162.59,0,0,1-76.31-17.85V173.59Z",
    style: {
      fill: "#DA2C32",
      stroke: "#DA2C32",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,173.59V396.32c-26.59,14-59.16,22.25-98.31,23a162.59,162.59,0,0,1-76.31-17.85V173.59Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 174.49,
    width: 7.73,
    height: 239.17,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.29 401.33 201.31 411.33 201.31 177.55 205.29 187.55 205.29 401.33",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "310.35 386.79 317.93 394.37 342.09 394.37 342.09 386.79 310.35 386.79",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "310.35 342.62 317.93 350.2 342.09 350.2 342.09 342.62 310.35 342.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "310.35 298.44 317.93 306.02 342.09 306.02 342.09 298.44 310.35 298.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "310.35 254.27 317.93 261.85 342.09 261.85 342.09 254.27 310.35 254.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "310.35 210.1 317.93 217.68 342.09 217.68 342.09 210.1 310.35 210.1",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.35 386.79 174.93 394.37 201.09 394.37 201.09 386.79 167.35 386.79",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.35 342.62 174.93 350.2 201.09 350.2 201.09 342.62 167.35 342.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.35 298.44 174.93 306.02 201.09 306.02 201.09 298.44 167.35 298.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.35 254.27 174.93 261.85 201.09 261.85 201.09 254.27 167.35 254.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.35 210.1 174.93 217.68 201.09 217.68 201.09 210.1 167.35 210.1",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.87,
    y1: 163.75,
    x2: 339.69,
    y2: 163.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.87,
    y1: 166.28,
    x2: 339.69,
    y2: 166.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.87,
    y1: 168.81,
    x2: 339.69,
    y2: 168.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.87,
    y1: 171.34,
    x2: 339.69,
    y2: 171.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.87,
    y: 161.5,
    width: 169.82,
    height: 12.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.23,
    y: 148.3,
    width: 197.1,
    height: 3.27,
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-97)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.23,
    y: 148.3,
    width: 197.1,
    height: 3.27,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.41,
    y: 148.3,
    width: 84.14,
    height: 3.27,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 156.23,
    y: 148.3,
    width: 197.1,
    height: 3.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.47 401.45 167.47 173.59 342.09 173.59 342.09 396.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "223.64 420.9 223.64 136.73 285.92 136.73 285.92 418.9",
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-97)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.64,
    y: 139.33,
    width: 62.28,
    height: 7.4,
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "223.64 420.9 223.64 136.73 285.92 136.73 285.92 418.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.28,
    y: 181.69,
    width: 17.27,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.42,
    y: 182.19,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,182.69v11.16h-6.63V182.69h6.63m1-1h-8.63v13.16h8.63V181.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.43,
    y: 181.69,
    width: 26.66,
    height: 25.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.24,
    y1: 181.69,
    x2: 179.24,
    y2: 206.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1,182.69v23.25h-6.95V182.69h6.95m1-1h-8.95v25.25h8.95V181.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 206.94,
    width: 37.82,
    height: 3.29,
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 197.1,
    x2: 199.21,
    y2: 197.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 199.63,
    x2: 199.21,
    y2: 199.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 202.16,
    x2: 199.21,
    y2: 202.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 204.69,
    x2: 199.21,
    y2: 204.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 194.85,
    width: 37.82,
    height: 12.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.58,
    y: 181.69,
    width: 5.68,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.01,
    y: 181.69,
    width: 17.27,
    height: 13.16,
    transform: "translate(545.29 376.54) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.51,
    y: 182.19,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.65,182.69v11.16H265V182.69h6.64m1-1H264v13.16h8.64V181.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.47,
    y: 181.69,
    width: 26.66,
    height: 25.25,
    transform: "translate(651.6 388.63) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.32,
    y1: 181.69,
    x2: 330.32,
    y2: 206.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.41,182.69v23.25h-6.94V182.69h6.94m1-1h-8.94v25.25h8.94V181.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 206.94,
    width: 37.82,
    height: 3.29,
    transform: "translate(658.53 417.18) rotate(180)",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 197.1,
    x2: 310.35,
    y2: 197.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 199.63,
    x2: 310.35,
    y2: 199.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 202.16,
    x2: 310.35,
    y2: 202.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 204.69,
    x2: 310.35,
    y2: 204.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 194.85,
    width: 37.82,
    height: 12.09,
    transform: "translate(658.53 401.8) rotate(180)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.31,
    y: 181.69,
    width: 5.68,
    height: 13.16,
    transform: "translate(594.29 376.54) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.28,
    y: 225.83,
    width: 17.27,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.42,
    y: 226.33,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,226.83V238h-6.63V226.83h6.63m1-1h-8.63V239h8.63V225.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.43,
    y: 225.83,
    width: 26.66,
    height: 25.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.24,
    y1: 225.83,
    x2: 179.24,
    y2: 251.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1,226.83v23.25h-6.95V226.83h6.95m1-1h-8.95v25.25h8.95V225.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 251.08,
    width: 37.82,
    height: 3.29,
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 241.24,
    x2: 199.21,
    y2: 241.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 243.77,
    x2: 199.21,
    y2: 243.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 246.3,
    x2: 199.21,
    y2: 246.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 248.83,
    x2: 199.21,
    y2: 248.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 238.99,
    width: 37.82,
    height: 12.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.58,
    y: 225.83,
    width: 5.68,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.01,
    y: 225.83,
    width: 17.27,
    height: 13.16,
    transform: "translate(545.29 464.82) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.51,
    y: 226.33,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.65,226.83V238H265V226.83h6.64m1-1H264V239h8.64V225.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.47,
    y: 225.83,
    width: 26.66,
    height: 25.25,
    transform: "translate(651.6 476.91) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.32,
    y1: 225.83,
    x2: 330.32,
    y2: 251.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.41,226.83v23.25h-6.94V226.83h6.94m1-1h-8.94v25.25h8.94V225.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 251.08,
    width: 37.82,
    height: 3.29,
    transform: "translate(658.53 505.45) rotate(180)",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 241.24,
    x2: 310.35,
    y2: 241.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 243.77,
    x2: 310.35,
    y2: 243.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 246.3,
    x2: 310.35,
    y2: 246.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 248.83,
    x2: 310.35,
    y2: 248.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 238.99,
    width: 37.82,
    height: 12.09,
    transform: "translate(658.53 490.07) rotate(180)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.31,
    y: 225.83,
    width: 5.68,
    height: 13.16,
    transform: "translate(594.29 464.82) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.28,
    y: 269.97,
    width: 17.27,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.42,
    y: 270.47,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,271v11.16h-6.63V271h6.63m1-1h-8.63v13.16h8.63V270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.43,
    y: 269.97,
    width: 26.66,
    height: 25.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.24,
    y1: 269.97,
    x2: 179.24,
    y2: 295.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1,271v23.25h-6.95V271h6.95m1-1h-8.95v25.25h8.95V270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 295.22,
    width: 37.82,
    height: 3.29,
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 285.38,
    x2: 199.21,
    y2: 285.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 287.91,
    x2: 199.21,
    y2: 287.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 290.44,
    x2: 199.21,
    y2: 290.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 292.97,
    x2: 199.21,
    y2: 292.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 283.13,
    width: 37.82,
    height: 12.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.58,
    y: 269.97,
    width: 5.68,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.01,
    y: 269.97,
    width: 17.27,
    height: 13.16,
    transform: "translate(545.29 553.1) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.51,
    y: 270.47,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.65,271v11.16H265V271h6.64m1-1H264v13.16h8.64V270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.47,
    y: 269.97,
    width: 26.66,
    height: 25.25,
    transform: "translate(651.6 565.19) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.32,
    y1: 269.97,
    x2: 330.32,
    y2: 295.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.41,271v23.25h-6.94V271h6.94m1-1h-8.94v25.25h8.94V270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 295.22,
    width: 37.82,
    height: 3.29,
    transform: "translate(658.53 593.73) rotate(180)",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 285.38,
    x2: 310.35,
    y2: 285.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 287.91,
    x2: 310.35,
    y2: 287.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 290.44,
    x2: 310.35,
    y2: 290.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 292.97,
    x2: 310.35,
    y2: 292.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 283.13,
    width: 37.82,
    height: 12.09,
    transform: "translate(658.53 578.35) rotate(180)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.31,
    y: 269.97,
    width: 5.68,
    height: 13.16,
    transform: "translate(594.29 553.1) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.28,
    y: 314.11,
    width: 17.27,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.42,
    y: 314.61,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,315.11v11.16h-6.63V315.11h6.63m1-1h-8.63v13.16h8.63V314.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.43,
    y: 314.11,
    width: 26.66,
    height: 25.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.24,
    y1: 314.11,
    x2: 179.24,
    y2: 339.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1,315.11v23.25h-6.95V315.11h6.95m1-1h-8.95v25.25h8.95V314.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 339.36,
    width: 37.82,
    height: 3.29,
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 329.52,
    x2: 199.21,
    y2: 329.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 332.05,
    x2: 199.21,
    y2: 332.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 334.58,
    x2: 199.21,
    y2: 334.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 337.11,
    x2: 199.21,
    y2: 337.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 327.27,
    width: 37.82,
    height: 12.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.58,
    y: 314.11,
    width: 5.68,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.01,
    y: 314.11,
    width: 17.27,
    height: 13.16,
    transform: "translate(545.29 641.38) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.51,
    y: 314.61,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.65,315.11v11.16H265V315.11h6.64m1-1H264v13.16h8.64V314.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.47,
    y: 314.11,
    width: 26.66,
    height: 25.25,
    transform: "translate(651.6 653.47) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.32,
    y1: 314.11,
    x2: 330.32,
    y2: 339.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.41,315.11v23.25h-6.94V315.11h6.94m1-1h-8.94v25.25h8.94V314.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 339.36,
    width: 37.82,
    height: 3.29,
    transform: "translate(658.53 682.01) rotate(180)",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 329.52,
    x2: 310.35,
    y2: 329.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 332.05,
    x2: 310.35,
    y2: 332.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 334.58,
    x2: 310.35,
    y2: 334.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 337.11,
    x2: 310.35,
    y2: 337.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 327.27,
    width: 37.82,
    height: 12.09,
    transform: "translate(658.53 666.63) rotate(180)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.31,
    y: 314.11,
    width: 5.68,
    height: 13.16,
    transform: "translate(594.29 641.38) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.28,
    y: 358.25,
    width: 17.27,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.42,
    y: 358.75,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,359.25v11.16h-6.63V359.25h6.63m1-1h-8.63v13.16h8.63V358.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.43,
    y: 358.25,
    width: 26.66,
    height: 25.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.24,
    y1: 358.25,
    x2: 179.24,
    y2: 383.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1,359.25V382.5h-6.95V359.25h6.95m1-1h-8.95V383.5h8.95V358.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 383.5,
    width: 37.82,
    height: 3.29,
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 373.66,
    x2: 199.21,
    y2: 373.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 376.19,
    x2: 199.21,
    y2: 376.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 378.72,
    x2: 199.21,
    y2: 378.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.39,
    y1: 381.25,
    x2: 199.21,
    y2: 381.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 371.41,
    width: 37.82,
    height: 12.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.58,
    y: 358.25,
    width: 5.68,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.01,
    y: 358.25,
    width: 17.27,
    height: 13.16,
    transform: "translate(545.29 729.66) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.51,
    y: 358.75,
    width: 7.63,
    height: 12.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.65,359.25v11.16H265V359.25h6.64m1-1H264v13.16h8.64V358.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.47,
    y: 358.25,
    width: 26.66,
    height: 25.25,
    transform: "translate(651.6 741.75) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.32,
    y1: 358.25,
    x2: 330.32,
    y2: 383.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.41,359.25V382.5h-6.94V359.25h6.94m1-1h-8.94V383.5h8.94V358.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 383.5,
    width: 37.82,
    height: 3.29,
    transform: "translate(658.53 770.29) rotate(180)",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 373.66,
    x2: 310.35,
    y2: 373.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 376.19,
    x2: 310.35,
    y2: 376.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 378.72,
    x2: 310.35,
    y2: 378.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.17,
    y1: 381.25,
    x2: 310.35,
    y2: 381.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 371.41,
    width: 37.82,
    height: 12.09,
    transform: "translate(658.53 754.91) rotate(180)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.31,
    y: 358.25,
    width: 5.68,
    height: 13.16,
    transform: "translate(594.29 729.66) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.64,
    y: 143.5,
    width: 62.28,
    height: 13.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-97)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.64,
    y: 143.5,
    width: 62.29,
    height: 3.77,
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 223.64,
    y: 143.5,
    width: 62.28,
    height: 13.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.66,
    y1: 143.5,
    x2: 230.66,
    y2: 156.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.7,
    y1: 143.5,
    x2: 238.7,
    y2: 156.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.74,
    y1: 143.5,
    x2: 246.74,
    y2: 156.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.78,
    y1: 143.5,
    x2: 254.78,
    y2: 156.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.82,
    y1: 143.5,
    x2: 262.82,
    y2: 156.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.86,
    y1: 143.5,
    x2: 270.86,
    y2: 156.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.91,
    y1: 143.5,
    x2: 278.91,
    y2: 156.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.79 137.7 215.78 137.7 226.81 124.16 282.75 124.16 293.79 137.7",
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-97)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "293.79 137.7 215.78 137.7 226.81 124.16 282.75 124.16 293.79 137.7",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "293.79 137.7 215.78 137.7 226.81 124.16 282.75 124.16 293.79 137.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.72,
    y: 136.06,
    width: 80.13,
    height: 3.27,
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-97)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.72,
    y: 136.06,
    width: 80.13,
    height: 3.27,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 214.72,
    y: 136.06,
    width: 80.13,
    height: 3.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.23,
    y: 160.52,
    width: 5.83,
    height: 2.34,
    transform: "translate(468.29 323.39) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.9,
    y: 163.2,
    width: 5.83,
    height: 2.34,
    transform: "translate(477.63 328.74) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.28,
    y: 176.38,
    width: 5.83,
    height: 2.34,
    transform: "translate(510.4 355.11) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.37,
    y: 179.47,
    width: 5.83,
    height: 2.34,
    transform: "translate(504.57 361.29) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.32,
    y: 200.37,
    width: 5.83,
    height: 2.34,
    transform: "translate(462.47 403.09) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.51,
    y: 203.29,
    width: 5.83,
    height: 2.34,
    transform: "translate(468.85 408.92) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.47,
    y: 206.07,
    width: 5.83,
    height: 2.34,
    transform: "translate(536.76 414.48) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.39,
    y: 209.19,
    width: 5.83,
    height: 2.34,
    transform: "translate(530.6 420.72) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.16,
    y: 221.42,
    width: 5.83,
    height: 2.34,
    transform: "translate(466.15 445.19) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.85,
    y: 200.37,
    width: 5.83,
    height: 2.34,
    transform: "translate(475.53 403.09) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.34,
    y: 268.27,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.67,
    y: 265.59,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.29,
    y: 250.41,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.2,
    y: 247.32,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 228.42,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.06,
    y: 225.5,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.98,
    y: 169.57,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.06,
    y: 166.45,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.32,
    y: 218.91,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.72,
    y: 228.42,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.7,
    y: 251.83,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.03,
    y: 249.15,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.65,
    y: 374.97,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.56,
    y: 393.87,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.61,
    y: 354.97,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.42,
    y: 352.06,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.47,
    y: 353.28,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.55,
    y: 350.16,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.77,
    y: 333.92,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.08,
    y: 354.97,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2,355.12c5.67-.06,11.51-.06,17,0",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.59,
    y: 284.08,
    width: 5.83,
    height: 2.34,
    transform: "translate(487.02 570.5) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.26,
    y: 286.76,
    width: 5.83,
    height: 2.34,
    transform: "translate(496.35 575.86) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.64,
    y: 301.94,
    width: 5.83,
    height: 2.34,
    transform: "translate(523.12 606.22) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.73,
    y: 336.03,
    width: 5.83,
    height: 2.34,
    transform: "translate(517.29 674.4) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.68,
    y: 319.93,
    width: 5.83,
    height: 2.34,
    transform: "translate(481.19 642.21) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.87,
    y: 322.84,
    width: 5.83,
    height: 2.34,
    transform: "translate(487.58 648.03) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.96,
    y: 383.78,
    width: 5.83,
    height: 2.34,
    transform: "translate(477.74 769.9) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.88,
    y: 386.9,
    width: 5.83,
    height: 2.34,
    transform: "translate(471.58 776.14) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.61,
    y: 329.44,
    width: 5.83,
    height: 2.34,
    transform: "translate(457.05 661.21) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.21,
    y: 319.93,
    width: 5.83,
    height: 2.34,
    transform: "translate(494.25 642.21) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.38,
    y: 375.81,
    width: 5.83,
    height: 2.34,
    transform: "translate(454.58 753.96) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.04,
    y: 373.13,
    width: 5.83,
    height: 2.34,
    transform: "translate(463.92 748.6) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.33,
    y: 378.73,
    width: 5.83,
    height: 2.34,
    transform: "translate(552.49 759.8) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.42,
    y: 375.64,
    width: 5.83,
    height: 2.34,
    transform: "translate(546.66 753.62) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.68,
    y: 343.57,
    width: 5.83,
    height: 2.34,
    transform: "translate(543.19 689.47) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.87,
    y: 340.65,
    width: 5.83,
    height: 2.34,
    transform: "translate(549.58 683.65) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.15,
    y: 358.48,
    width: 5.83,
    height: 2.34,
    transform: "translate(508.12 719.31) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.07,
    y: 355.37,
    width: 5.83,
    height: 2.34,
    transform: "translate(501.96 713.08) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.95,
    y: 387.95,
    width: 5.83,
    height: 2.34,
    transform: "translate(515.73 778.24) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.21,
    y: 343.57,
    width: 5.83,
    height: 2.34,
    transform: "translate(556.25 689.47) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.34,
    y: 286.13,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.67,
    y: 288.81,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.97,
    y: 301.02,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.88,
    y: 304.12,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.93,
    y: 336.14,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.74,
    y: 339.05,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.37,
    y: 311.06,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 336.14,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.7,
    y: 302.57,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.03,
    y: 305.25,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.46,
    y: 169.57,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.62,
    y: 161.04,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.24,
    y: 197.97,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.04,
    y: 200.88,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.8,
    y: 165.28,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.88,
    y: 168.4,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.77,
    y: 220.47,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.71,
    y: 197.97,
    width: 5.83,
    height: 2.34,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 214.15,
    width: 5.83,
    height: 2.34,
    transform: "translate(472.83 430.64) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.17,
    y: 211.47,
    width: 5.83,
    height: 2.34,
    transform: "translate(482.16 425.28) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.28,
    y: 259.53,
    width: 5.83,
    height: 2.34,
    transform: "translate(500.38 521.39) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.73,
    y: 218.37,
    width: 5.83,
    height: 2.34,
    transform: "translate(517.29 439.07) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.42,
    y: 257.06,
    width: 5.83,
    height: 2.34,
    transform: "translate(497.45 527.07) rotate(-177.56)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.74,
    y: 254.29,
    width: 5.83,
    height: 2.34,
    transform: "matrix(-1, -0.04, 0.04, -1, 504.2, 521.66)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.8,
    y: 194.7,
    width: 5.83,
    height: 2.34,
    transform: "translate(511.43 391.75) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.72,
    y: 191.59,
    width: 5.83,
    height: 2.34,
    transform: "translate(505.27 385.52) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.14,
    y: 239.99,
    width: 5.83,
    height: 2.34,
    transform: "translate(497.61 492.92) rotate(-177.56)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.95,
    y: 257.34,
    width: 5.83,
    height: 2.34,
    transform: "translate(510.48 527.9) rotate(-177.56)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.31,
    y1: 177.55,
    x2: 201.31,
    y2: 403.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.55,
    y1: 177.55,
    x2: 308.55,
    y2: 403.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.34,127.05h3.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,127q14.76,0,29.52,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.46,127.05l10.23,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.1,
    y1: 129.93,
    x2: 240.25,
    y2: 129.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.06,129.93q-14.22.06-28.44,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.8,
    y1: 133.25,
    x2: 287.06,
    y2: 133.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.59,
    y1: 133.25,
    x2: 268.09,
    y2: 133.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.18,
    y1: 133.25,
    x2: 245.54,
    y2: 133.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.4,
    y1: 133.25,
    x2: 222.3,
    y2: 133.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.26,
    y1: 129.93,
    x2: 253.85,
    y2: 129.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.93,226.16l-8.81-6.55v3.55H112a5,5,0,0,1-5-5V211h34.71a3.82,3.82,0,0,0,3.81-3.82V189.79a3.82,3.82,0,0,0-3.81-3.82H66.27a3.81,3.81,0,0,0-3.81,3.82v17.36A3.81,3.81,0,0,0,66.27,211H101v8.65a9.54,9.54,0,0,0,9.53,9.54h44.61v3.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.5 192.92 77.3 196.57 81.33 197.16 78.42 200 79.11 204.02 75.5 202.13 71.89 204.02 72.58 200 69.66 197.16 73.69 196.57 75.5 192.92",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.74 192.92 91.54 196.57 95.58 197.16 92.66 200 93.35 204.02 89.74 202.13 86.13 204.02 86.82 200 83.9 197.16 87.93 196.57 89.74 192.92",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.98 192.92 105.78 196.57 109.82 197.16 106.9 200 107.59 204.02 103.98 202.13 100.37 204.02 101.06 200 98.14 197.16 102.17 196.57 103.98 192.92",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.22 192.92 120.03 196.57 124.06 197.16 121.14 200 121.83 204.02 118.22 202.13 114.61 204.02 115.3 200 112.38 197.16 116.42 196.57 118.22 192.92",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.46 192.92 134.27 196.57 138.3 197.16 135.38 200 136.07 204.02 132.46 202.13 128.85 204.02 129.54 200 126.62 197.16 130.66 196.57 132.46 192.92",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-2--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.58,200.89v37.4S362.17,266.7,344.9,275.11,309.06,301,309.06,301c-6.2,6.42-29,11.73-27.89,5.79a22.42,22.42,0,0,0,.14-6.52,30.69,30.69,0,0,0-1.24-5.91c-2,3.76-6.42,8-6.42,8,0,4.42-2.66,11.73-2.66,11.73l-1,14.16c4.54,8.19.54,11.5-1.18,11.28s-3.67-3.22-3.67-3.22l-2.57.35s-3.1,6.41-5.54,6.64-3.8-3.32-3.8-3.32-1.29,2.43-4.38,1a4.56,4.56,0,0,1-1.78-2.13c-1.93-3.87-3-11.53-3.31-14.32-.45-3.54-.89-19.92-.89-21.91s11.07-19,14.39-24.79,5.75-12.83,10.17-15.26,9.3-.45,23.68-1.33,26.78-3.76,33.29-6.2,8.09-5.75,17.61-8S446.92,201.12,447.58,200.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.13,293a48.26,48.26,0,0,1-1.82,7.25,30.69,30.69,0,0,0-1.24-5.91c-2,3.76-6.42,8-6.42,8,0,4.42-2.66,11.73-2.66,11.73l-1,14.16c4.54,8.19.54,11.5-1.18,11.28s-3.67-3.22-3.67-3.22l-2.57.35s-3.1,6.41-5.54,6.64-3.8-3.32-3.8-3.32-1.29,2.43-4.38,1a4.56,4.56,0,0,1-1.78-2.13c1.11.5,2.45,0,3.66-3.26a15.61,15.61,0,0,0-1.29-13.5s4.6-9.84,4.41-12.22-2.74-4.67-1.8-6.29,3.21,1.28,5-.56,8.39-12.18,8.12-13.35,1.67-1.1,2.68-2,.78-5.27,2.14-4.73,2.81,1.34,2.81,1.34a11.06,11.06,0,0,0,0-3c-.26-.5,4.82,4.7,6.3,4.91S283.7,287.71,283.13,293Z",
    style: {
      fill: "#DA2C32",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.58,200.89c-.66.23-96,43.9-105.55,46.12s-11.11,5.53-17.61,8-18.9,5.31-33.29,6.2-19.25-1.11-23.68,1.33-6.86,9.51-10.17,15.26-14.39,22.8-14.39,24.79.44,18.37.89,21.91,2,15,5.09,16.45,4.38-1,4.38-1,1.37,3.54,3.8,3.32,5.54-6.64,5.54-6.64l2.57-.35s1.94,3,3.67,3.22,5.72-3.09,1.18-11.28l1-14.16s2.65-7.31,2.65-11.73c0,0,4.43-4.21,6.42-8,0,0,2.21,6.49,1.1,12.43s21.69.63,27.89-5.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.25,340s3.67-10,0-16.16a17,17,0,0,0,1.63-4.64c.51-2.66,1.68-10.13,1.34-11.29s.83-2.49.83-2.49a31.08,31.08,0,0,0,4.15-5c2.16-3.15,5.15-9,5.15-9s2.16-.66,4.81-3.82c0,0,2.82-.83,4.32,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.79,288.28s1.49,4.78,0,8.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.07,294.36s-.61-3.59-1.94-4.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,291.43s3.21,4.14,10,2.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.33,296.73s-4.32,8.33-6,10.06l-1,5.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.88,306.79a6.31,6.31,0,0,0,5.31,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.65,302.33s-3.37,3-4.82,2.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.83,283a7,7,0,0,1,2.33,4.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.18,279.65c-.19.49,2.3,4.64,4.13,6.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.07,304.69a5.89,5.89,0,0,0,5,.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.75,323.29s2.8.21,3.3-1.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.26,
    cy: 342.6,
    rx: 7.88,
    ry: 9.99,
    transform: "translate(-31.69 26.27) rotate(-5.51)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.37,352.08a8.61,8.61,0,0,0-15.9.49l-5.73,15.13a8.61,8.61,0,0,0,16.11,6.09l5.72-15.12A8.58,8.58,0,0,0,258.37,352.08Zm-6.48-.09a1.46,1.46,0,1,1,1.89-.84A1.47,1.47,0,0,1,251.89,352Z",
    style: {
      fill: "#DA2C32",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.25,357.79l-5.72,15.12a6.13,6.13,0,0,1-11.46-4.33l5.72-15.13a6,6,0,0,1,2.68-3.12,6.27,6.27,0,0,0,8.86,3.34A6.14,6.14,0,0,1,256.25,357.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.12,370a2.16,2.16,0,0,1-.88-.22l-1.08-.41c-.64-.25-1-.12-1.15.37l-.14.38,2.8,1.07-.41,1.08-6.89-2.63L242,368a1.49,1.49,0,0,1,2.2-1l.54.21a1.47,1.47,0,0,1,1.12,1.24h0c.43-.46,1-.44,1.73-.17l1.06.41a2.19,2.19,0,0,0,.89.2Zm-6.36-1.07,2.12.81.16-.42c.16-.41.07-.72-.48-.93l-.68-.26c-.49-.19-.77-.1-.92.28Z",
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.2,365.7l.56-1.49,1,.38-.57,1.49,2,.77.71-1.87,1,.37-1.13,3-6.89-2.63,1.12-3,1,.38-.71,1.87Z",
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.54,361.79v0l5,1.9-.37,1-6.89-2.63.51-1.36,4.55.48v0l-4.13-1.57.37-1,6.89,2.63-.42,1.12Z",
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.75,358.16l1.27-3.35,1,.37-.43,1.14,5.91,2.25-.42,1.08-5.91-2.25-.43,1.13Z",
    style: {
      fill: "#DA2C32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.66,348.66,246,354.13a2,2,0,0,0-1,2.71l7.16,15.34a2,2,0,0,0,2.71,1l3.4-1.59,12.2,26.13a1.42,1.42,0,0,0,1.89.69l2.33-1.09a1.42,1.42,0,0,0,.69-1.89l-12.2-26.13,3.41-1.59a2,2,0,0,0,1-2.71l-7.16-15.35A2,2,0,0,0,257.66,348.66Zm2,3.25a1.71,1.71,0,0,1-.82,2.28l-.37.17a1.71,1.71,0,0,1-2.27-.83l-.17-.36a1.72,1.72,0,0,1,.82-2.28l.37-.17a1.71,1.71,0,0,1,2.27.84Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "272.6 395.94 260.61 370.25 261.86 369.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.11,341.85c.53,5.49-2.56,10.28-6.89,10.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.58,209.52v43.15l-3.39.88h0c-16.33,4.24-85.85,22.29-91.51,24.44-6.42,2.43-12.83,6.19-15,6.63s-13.72,13.5-17.26,16.82-12.17,7.08-22.13,9.74-19.25,9.74-21.68,11.95-14.83,19-17.71,17.7c-2.26-1.05-5.5-1.68-5.57-6.45a18.14,18.14,0,0,1,.71-4.83c2.43-9.3,7.74-16.6,12.83-18.37s17.26-17.48,17.7-21.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.16,253.55c-16.33,4.24-85.85,22.29-91.51,24.44-6.42,2.43-12.83,6.19-15,6.63s-13.72,13.5-17.26,16.82-12.17,7.08-22.13,9.74-19.25,9.74-21.68,11.95-14.83,19-17.71,17.7c-2.26-1.05-5.5-1.68-5.57-6.45,1.43,2.27,3.71,4.91,4.63,3.91,0,0-2.69-.2,0-6.73s4-9.69,7.3-7.32,7.15,3.17,8.48-1.58,1.81-2.57,7.8-6.53,12.32-10.6,14.1-10.44,15.63-1.15,19.78-3.36,16-15.54,16.31-19.37,15.09-9.36,18.78-11.53,18.12-4.95,23.66-6.13-8.31,3.88-12.46,6.78,35-9.95,45.29-11.93C417,258.22,443.14,253.73,444.16,253.55Z",
    style: {
      fill: "#DA2C32",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.58,252.67S359.07,275.55,352.65,278s-12.83,6.19-15,6.63-13.72,13.5-17.26,16.82-12.17,7.08-22.13,9.74-19.25,9.74-21.68,11.95-14.83,19-17.71,17.7-7.3-2-4.86-11.28,7.74-16.6,12.83-18.37,17.26-17.48,17.7-21.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-1--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.63,418.46c-5.4,5.42-21.74,13.15-27.59,17.3-4.14,2.94-21.39,5.61-26.41,7.08-3.56,1.05-8.31,5.13-13.06,3.78s-44.31-20.35-53.8-25.09-58.55,2.7-87.82,1.74c-1.91-.06-3.74-.12-5.49-.16-25.19-.67-34.87.16-34.87.16l13.45-52S81,372.47,119,379.2c7.67,1.36,14.62,2.45,20.84,3.34,24.6,3.51,37.7,3.75,37.7,3.75s12.66-11,24.53-1.55,15,17.4,15,17.4l16.62,9.5s6.73-1.19,10.88,0,10-2.77,13-4.35a51.78,51.78,0,0,1,16.88-5.15s10.23-3.95,17.75-2c0,0,5.54-2.37,10.29-2.37a8.56,8.56,0,0,1,3.57.74,7.35,7.35,0,0,1,3.15,2.62,33.81,33.81,0,0,1,.79,4.16C310.42,408.08,303.69,406.34,291.63,418.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.63,418.46c-5.4,5.42-21.74,13.15-27.59,17.3-4.14,2.94-21.39,5.61-26.41,7.08-3.56,1.05-8.31,5.13-13.06,3.78s-44.31-20.35-53.8-25.09-58.55,2.7-87.82,1.74c-1.91-.06-3.74-.12-5.49-.16,12.66-.83,26-1.8,30.11-2.47,8.44-1.39,50.54-3.56,56.39-4.06s52,23.51,57.28,25.88,9,2.64,12.43,0,17.08-5,17.08-5l-7.86.71s10.45-3.78,17.23-5.46,13.52-7.81,18-9.23,12.26-10.31,16.17-12.14,0-7.26,0-7.26,4.73-.18,6.59,2.75c0,0,6.92.23,8.34-5.67a33.81,33.81,0,0,1,.79,4.16C310.42,408.08,303.69,406.34,291.63,418.46Z",
    style: {
      fill: "#DA2C32",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.08,398.53c-11.43,3-13.86,4.91-13.86,4.91-2.08-.62-15.59,7.9-16.74,8.59s-1.83,4-1.83,4-3.88-4-10.46.59-7.3,7.44-7.3,7.44l-2.64-3.38s-11.17,1-14.58.45A16.53,16.53,0,0,1,230.9,418c-2.61-1.74-16.49-7.58-17.92-8s-3.24-3.08-3.24-3.08c-2.53-10.16-15.14-21.76-22-20.84a25.16,25.16,0,0,0-11.43,4.62s-12.84-1.32-19.43-1.58-46.68-7.65-46.68-7.65l29.58,1c24.6,3.51,37.7,3.75,37.7,3.75s12.66-11,24.53-1.55,15,17.4,15,17.4l16.62,9.5s6.73-1.19,10.88,0,10-2.77,13-4.35a51.78,51.78,0,0,1,16.88-5.15s10.23-3.95,17.75-2c0,0,5.54-2.37,10.29-2.37A8.56,8.56,0,0,1,306.08,398.53Z",
    style: {
      fill: "#DA2C32",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.81,414.31s.07,2.8-1.39,2.54,2.65,3.85,5.28,3.19,9.1,5.28,11.61,7.92,24.33,6.06,29,5.93,8.19-4.94,4.9-9.79c0,0-.6,4.78-3.52,4.25,0,0,2.8-1.05-1.38-5s-10.39-5.67-11.71-4.88-9.34-2.5-9.81-3,.71,11.41-6.28,11c0,0-7.83-5.78-9.39-8.17S187.81,414.31,187.81,414.31Z",
    style: {
      fill: "#DA2C32",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,371.29S81,372.47,119,379.2s58.54,7.09,58.54,7.09,12.66-11,24.53-1.55,15,17.4,15,17.4l16.62,9.5s6.73-1.19,10.88,0,10-2.77,13-4.35a51.78,51.78,0,0,1,16.88-5.15s10.23-3.95,17.75-2c0,0,5.54-2.37,10.29-2.37a7.85,7.85,0,0,1,6.72,3.36,33.81,33.81,0,0,1,.79,4.16c.4,2.77-6.33,1-18.39,13.15-5.4,5.42-21.74,13.15-27.59,17.3-4.14,2.94-21.39,5.61-26.41,7.08-3.56,1.05-8.31,5.13-13.06,3.78s-44.31-20.35-53.8-25.09-58.55,2.7-87.82,1.74-40.36,0-40.36,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.19,418.56h12.26s10.48-4,18.4-6.13c0,0,11.47-7.52,15.23-8.7s8.11,0,9.69,2.17a9.58,9.58,0,0,1,1.58,5s-11.08,7.25-14.24,10-9.89,5.34-17.21,10.09-20.64,5-25.71,7.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22,400.16s-12.83,4.74-18.68,11.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.77,412s-9.59,2.57-16.52,4.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,411.83s-.88,1.19,0,3.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4,413.66s4.74,2.13,7.31,3.52,5.64,8.2,9.1,9.79,8.9,2.27,16,3.26S235.45,433,237,426.77s-9.19-10.29-14.73-13.11a41.54,41.54,0,0,0-9.32-3.59s-2.75-2.59-3.74-3.58-1-6.13-2-8.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.79,400.16s-.26,4.45-2,6.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.9,416a13,13,0,0,1,2.77-4.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,416.58s5.28,1.19,7.61,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.19,405.21a7.44,7.44,0,0,1-2.93,3.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.74,416.58s.79,5.34-3.76,8.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg);
export default __webpack_public_path__ + "static/media/about-img.bb0f07670f806d86ecfa58c6332bbd36.svg";
export { ForwardRef as ReactComponent };